/**
 * Goal Setting Preview Step
 * Shows compact mockup of goal setting interface
 */

import { Target, Calendar } from 'lucide-react';
import { OnboardingStep } from '../OnboardingStep';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

function GoalSettingMockup() {
  return (
    <div className="w-full max-w-md mx-auto space-y-4 p-3 pointer-events-none select-none">
      {/* Goal Type Selection */}
      <div>
        <h3 className="text-sm font-semibold text-foreground mb-2.5">
          เลือกประเภทเป้าหมาย
        </h3>
        <div className="grid grid-cols-2 gap-2.5">
          <Card className={cn(
            "cursor-pointer transition-all border-2",
            "border-primary bg-primary/5"
          )}>
            <CardContent className="p-3 text-center">
              <div className="w-10 h-10 mx-auto mb-1.5 rounded-full bg-primary/10 flex items-center justify-center">
                <Target className="w-5 h-5 text-primary" />
              </div>
              <p className="text-xs font-semibold text-foreground">รายวัน/สัปดาห์</p>
              <p className="text-[10px] text-muted-foreground mt-0.5">
                กำหนดเป้าหมายตามตารางของคุณ
              </p>
            </CardContent>
          </Card>

          <Card className="cursor-pointer transition-all border-2 border-border hover:border-muted-foreground/20">
            <CardContent className="p-3 text-center">
              <div className="w-10 h-10 mx-auto mb-1.5 rounded-full bg-muted/50 flex items-center justify-center">
                <Calendar className="w-5 h-5 text-muted-foreground" />
              </div>
              <p className="text-xs font-semibold text-foreground">เป้าหมายรอมฎอน</p>
              <p className="text-[10px] text-muted-foreground mt-0.5">
                จบกุรอานในเดือนรอมฎอน
              </p>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Khatm Target */}
      <div>
        <label className="text-sm font-semibold text-foreground block mb-2">
          จำนวน Khatm ที่ต้องการอ่าน
        </label>
        <div className="flex items-center gap-3">
          <button className="w-9 h-9 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center text-lg font-bold">
            −
          </button>
          <div className="flex-1 text-center">
            <div className="text-2xl font-bold text-primary">1</div>
            <p className="text-[10px] text-muted-foreground">Khatm (604 หน้า)</p>
          </div>
          <button className="w-9 h-9 rounded-lg bg-muted hover:bg-muted/80 flex items-center justify-center text-lg font-bold">
            +
          </button>
        </div>
      </div>
    </div>
  );
}

export function GoalSettingPreviewStep() {
  return (
    <OnboardingStep
      title="ตั้งเป้าหมายที่เหมาะกับคุณ"
      description="เลือกประเภทเป้าหมาย กำหนดจำนวน Khatm และระยะเวลาที่ต้องการ"
      illustration={<GoalSettingMockup />}
    />
  );
}

export default GoalSettingPreviewStep;
